import design from '../../design.json';
import { cn } from '../lib/utils';

interface LogoProps {
  className?: string;
  size?: number;
  withWordmark?: boolean;
  /** When true, renders for use on dark/brand surfaces. */
  onDark?: boolean;
}

export function Logo({
  className,
  size = 32,
  withWordmark = false,
  onDark = false,
}: LogoProps): JSX.Element {
  return (
    <div className={cn('inline-flex items-center gap-2.5', className)}>
      <img
        src={design.logos.primary.url}
        alt="Voice of Nigeria"
        width={size}
        height={size}
        className="rounded"
        loading="eager"
        decoding="async"
      />
      {withWordmark ? (
        <div className="flex flex-col leading-none">
          <span
            className={cn(
              'font-heading text-[15px] font-semibold tracking-tight',
              onDark ? 'text-white' : 'text-ink',
            )}
          >
            {design.organisation.abbreviation}
          </span>
          <span
            className={cn(
              'mt-1 font-mono text-[9.5px] uppercase tracking-[0.22em]',
              onDark ? 'text-white/50' : 'text-ink-subtle',
            )}
          >
            Newsroom · Admin
          </span>
        </div>
      ) : null}
    </div>
  );
}
